import type { ReactNode } from 'react';

/**
 * Canonical "account pill" chrome: a brand-tinted rounded-full capsule holding a
 * value (USDC balance / points) beside a small avatar. Shared by the header
 * wallet-dropdown trigger and the rewards points menu so the two stay in sync.
 *
 * Apply `ACCOUNT_PILL_CLASS` to the interactive trigger element (a `<Link>` or a
 * dropdown trigger button) and wrap its contents in `<AccountPillBody>`.
 */
export const ACCOUNT_PILL_CLASS =
  'bg-background-brand border border-border-brand p-1 pl-2.5 rounded-full flex w-fit shrink-0 items-center gap-2 transition-opacity duration-fast ease-default motion-reduce:transition-none touch-target cursor-pointer outline-none focus-visible:ring-[3px] focus-visible:ring-button-primary-ring/30 hover:border-border-brand';

export function AccountPillBody({ children }: { children: ReactNode }): ReactNode {
  return <span className="pointer-events-none flex items-center gap-2">{children}</span>;
}
